import * as api from 'services/api';
import qs from 'qs';
import { addError } from 'actions/error';

export const getVacancyInfo = (id) => (dispatch) =>
  api.get(`vacancies/${id}`, 'GET_VACANCY_INFO', dispatch).catch((error) => {
    dispatch(addError(new Error('GET_VACANCY_INFO_ERROR')));
    return error;
  });

export const handleVacancyApplication = (id, data) => (dispatch) =>
  api.post(`vacancies/${id}/apply`, data, 'HANDLE_VACANCY_APPLICATION', dispatch).catch((error) => {
    dispatch(addError(new Error('HANDLE_VACANCY_APPLICATION_ERROR')));
    return error;
  });

export const getLocationsList = (options) => (dispatch) => {
  const queryString = qs.stringify(options, { arrayFormat: 'index' });

  return api.get(`locations?${queryString}`, 'GET_LOCATIONS_LIST', dispatch).catch((error) => {
    return error;
  });
};

export const getUploadUrl = (vacancyId, mimetype) => (dispatch) => {
  return api
    .get(
      `vacancies/${vacancyId}/apply/upload-resume-url?mimetype=${mimetype}`,
      'GET_UPLOAD_URL',
      dispatch
    )
    .catch((error) => {
      return error;
    });
};

export const getVacanciesFilterOptions = (filters = {}) => (dispatch) => {
  const queryParams = new URLSearchParams();
  const normalizedFilters = { ...filters };
  if (normalizedFilters.locationId !== undefined) {
    normalizedFilters.location_id = normalizedFilters.locationId;
    delete normalizedFilters.locationId;
  }
  Object.entries(normalizedFilters).forEach(([key, value]) => {
    if (value !== undefined && value !== null && value !== '') {
      if (Array.isArray(value)) {
        value.forEach((v) => queryParams.append(`filters[${key}]`, v));
      } else if (typeof value === 'string' && value.includes(',')) {
        value.split(',').forEach((v) => {
          if (v.trim()) {
            queryParams.append(`filters[${key}]`, v.trim());
          }
        });
      } else {
        queryParams.append(`filters[${key}]`, value);
      }
    }
  });

  const queryString = queryParams.toString();
  const url = `vacancies/filter-options${queryString ? `?${queryString}` : ''}`;

  return api.get(url, 'GET_VACANCIES_FILTER_OPTIONS', dispatch).catch((error) => {
    dispatch(addError(new Error('GET_VACANCIES_FILTER_OPTIONS_ERROR')));
    return {};
  });
};
